<template>
    <section class="py-5" style="padding-top: 0rem !important;background: #9DB0B0;">
        <top-home />
    </section>
    <section class="pb-5">
        <puzzles-home />
    </section>
    <section class="pb-5">
        <strategy-home />
    </section>
    <section class="pb-5">
        <sports-home />
    </section>
    <section class="pb-5">
        <adventure-home />
    </section>
    <section class="pb-5">
        <arcade-home />
    </section>
</template>

<script setup>
import { watchEffect } from 'vue';
import { HTTPSPA } from '@/Api/http-Spay';
import { useRouter } from 'vue-router';
import { useCookie } from 'vue-cookie-next';
import { useToast } from 'vue-toastification';
import AdventureHome from './HomePage/AdventureHome.vue';
import ArcadeHome from './HomePage/ArcadeHome.vue';
import PuzzlesHome from './HomePage/PuzzlesHome.vue';
import SportsHome from './HomePage/SportsHome.vue';
import StrategyHome from './HomePage/StrategyHome.vue';
import TopHome from './HomePage/TopHome.vue';
import axios from 'axios';

const router = useRouter();
const cookie = useCookie();
const toast = useToast();

watchEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const phoneNumber = urlParams.get('phoneNumber');
    const clickId = urlParams.get('click_id');
    if (phoneNumber) {
        try {
            const is12Digits = phoneNumber.length === 12;
            const username = is12Digits ? phoneNumber : `2491${phoneNumber}`;
            HTTPSPA.post(`CheckLogin.php?username=${username}&serviceId=2222&operatorID=2`).then((res) => {
                if (res.data.status == 1) {
                    cookie.setCookie('msisdn', username, { expire: 60 * res.data.MINTUES });
                    cookie.setCookie('status', res.data.status, { expire: 60 * res.data.MINTUES });
                    cookie.setCookie('MINTUES', res.data.MINTUES, { expire: 60 * res.data.MINTUES });
                    // Call push notification API for active subscriber
                    axios.get(`https://la3bttna.com/CallbackSudaniAlbatros/APIs/push-notfications.php?click_id=${clickId}&phoneNumber=${username}`)
                      .then(response => {
                        const data = response.data;
                        if (data.errorcode == 0) {
                          console.log(data.message || 'تم إرسال الإشعار بنجاح', { timeout: 2000 });
                        } else {
                          console.error('حدث خطأ أثناء إرسال الإشعار', { timeout: 2000 });
                        }
                      })
                      .catch(error => {
                        console.error('تعذر الاتصال بخدمة الإشعارات', { timeout: 2000 });
                        console.error('Error while:', error.message);
                      });
                } else if (res.data.status == 0 && res.data.responseCode == 118) {
                    cookie.setCookie('msisdn', username, { expire: 60 * 120 });
                    toast.warning('عفوا انت مشترك مسبقا ولم يتم تجديد اشتراكك', { timeout: 2500 });
                    // Call push notification API for expired subscriber
                    axios.get(`https://la3bttna.com/CallbackSudaniAlbatros/APIs/push-notfications.php?click_id=${clickId}&phoneNumber=${username}`)
                      .then(response => {
                        const data = response.data;
                        if (data.errorcode == 0) {
                          console.success(data.message || 'تم إرسال الإشعار بنجاح', { timeout: 2000 });
                        } else {
                          console.error('حدث خطأ أثناء إرسال الإشعار', { timeout: 2000 });
                        }
                      })
                      .catch(error => {
                        console.error('تعذر الاتصال بخدمة الإشعارات', { timeout: 2000 });
                        console.error('Error while added:', error.message);
                      });
                } else if (res.data.status == 0 && res.data.responseCode == 117) {
                    toast.error('عفوا انت لست مشترك في هذه الخدمة ', { timeout: 2500 });
                } else {
                    toast.error('عفوا انت لست مشترك في هذه الخدمة ', { timeout: 2500 });

                }
            });

            // Clear URL parameters and redirect
            setTimeout(() => {
                window.history.replaceState({}, document.title, window.location.pathname);
                router.push({ path: '/' });
            }, 2000);

        } catch (error) {
            console.error('Error checking login status:', error);
            cookie.removeCookie('msisdn');
            toast.error('حدث خطأ، يرجى المحاولة مرة أخرى', { timeout: 1000 });
            setTimeout(() => {
                window.history.replaceState({}, document.title, window.location.pathname);
                router.push({ path: '/' });
            }, 2000);
        }
    }
});
</script>

<style></style>